"use client";
import React from "react";
import { Row, Col } from "@/utils/bootstrap";
import SliderSkeleton from "./SliderSkeleton";
import { useIsMobile } from "@/hooks/useIsMobile";

const ProductPageSkeleton: React.FC = () => {
  const mobile = useIsMobile();
  const mClass = mobile ? "-mobile" : "";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 24,
        marginTop: 24,
      }}
    >
      {/* Breadcrumb Skeleton */}
      <div style={{ width: 200, height: 20 }} className="skeleton-rect rounded" />

      <Row className="m-0">
        <Col className={mobile ? "p-0" : ""} lg={4}>
          <SliderSkeleton />
        </Col>

        <Col className={mobile ? "p-0 pt-3" : ""} lg={8}>
          <div className={`product-details-container${mClass}`}>
            {/* Title */}
            <div style={{ width: "70%", height: 32, marginBottom: 16 }} className="skeleton-rect rounded" />
            
            {/* Rating */}
            <div style={{ width: 120, height: 20, marginBottom: 24 }} className="skeleton-rect rounded" />

            {/* Price */}
            <div style={{ width: 150, height: 40, marginBottom: 24 }} className="skeleton-rect rounded" />

            {/* Short Description / Info */}
            <div style={{ width: "100%", height: 20, marginBottom: 8 }} className="skeleton-rect rounded" />
            <div style={{ width: "90%", height: 20, marginBottom: 8 }} className="skeleton-rect rounded" />
            <div style={{ width: "80%", height: 20, marginBottom: 24 }} className="skeleton-rect rounded" />

            {/* Attributes / Options */}
            <div style={{ display: "flex", gap: 12, marginBottom: 24 }}>
              <div style={{ width: 60, height: 40 }} className="skeleton-rect rounded" />
              <div style={{ width: 60, height: 40 }} className="skeleton-rect rounded" />
              <div style={{ width: 60, height: 40 }} className="skeleton-rect rounded" />
            </div>

            {/* Add to Cart / Quantity */}
            <div style={{ display: "flex", gap: 16, height: 50 }}>
               <div style={{ width: 120, height: "100%" }} className="skeleton-rect rounded" />
               <div style={{ width: 200, height: "100%" }} className="skeleton-rect rounded" />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ProductPageSkeleton;
